export default "__VITE_ASSET__5b025ca9__"